<template>
	<div class="form-group mb-3" v-show="shouldShow()">
		
		<label :for="getConfig('wizard')">
      <Lock v-if="item.response_private" />
			{{item.label | multitranslate}}
			<span v-if="item.required">*</span>
		</label>

		<p v-if="item.instructions" class="mb-2">
			{{item.instructions | multitranslate}}
		</p>

    <textarea 
      v-if="type === 'description'"
      class="form-control form-control-user" :id="getConfig('wizard')" v-model="content" :required="item.required === 1">
    </textarea>
      
    <input 
      v-if="type === 'email' || type === 'text'"
      class="form-control form-control-user" 			
      :type="type"
      v-model="content"
      :required="item.required === 1">

    <input 
      v-if="type === 'entier'"
      class="form-control form-control-user" 			
      type="number"
      step="1"
      v-model="content"
      :required="item.required === 1">

    <input 
      v-if="type === 'decimal'"
      class="form-control form-control-user" 			
      type="number"
      step="0.1"
      v-model="content"
      :required="item.required === 1">
          

	</div>
</template>

<style scoped>
  .form-control {
    border-radius: 10px !important;
  }

  .form-group p {
    display: block;
    width: 100%;
  }

  label {
    font-weight: bold;
    text-transform: uppercase;
    font-family: Montserrat, sans-serif, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color :#373e46;
    margin-bottom: 0 !important;
  }

  .form-group span {
    color: red;
  }
</style>

<script>
import AbstractForm from './AbstractForm.vue';
export default {
  extends: AbstractForm,
  name: 'Input',
  props: ['item'],
  data: function() {
    return {
      content: '',
      type:null
    }
  },
  created() {
    this.getType();
  },
  methods: {
    getType:function(){
      switch (this.getConfig('wizard')) {
        case 'description':
          this.type = 'description'
          break;

        case 'email':
          this.type = 'email'
          break;

        case 'entier':
          this.type = 'entier'
          break;

        case 'décimal':
          this.type = 'decimal'
          break;
      
        default:
          this.type = 'text'
          break;
      }
    }
  }
}
</script>
